var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastextract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9567 6.92308C32.5737 6.92308 33.8846 8.23394 33.8846 9.85097V30.0208C33.8846 31.6378 32.5737 32.9487 30.9567 32.9487H10.0433C8.42624 32.9487 7.11539 31.6378 7.11539 30.0208V9.85097C7.11539 8.23394 8.42624 6.92308 10.0433 6.92308H30.9567ZM30.9567 8.875H10.0433C9.50427 8.875 9.06731 9.31197 9.06731 9.85097V30.0208C9.06731 30.5599 9.50427 30.9968 10.0433 30.9968H30.9567C31.4957 30.9968 31.9327 30.5599 31.9327 30.0208V9.85097C31.9327 9.31197 31.4957 8.875 30.9567 8.875ZM20.5 13.4697C20.9941 13.4697 21.4025 13.8369 21.4672 14.3132L21.476 14.4457L21.4751 23.1786L22.7269 21.9279C23.0734 21.5814 23.6157 21.5499 23.9977 21.8334L24.1072 21.9279C24.4537 22.2745 24.4852 22.8165 24.2016 23.1987L24.1072 23.3082L21.1901 26.2251L21.1403 26.2715L21.059 26.3352L20.9725 26.3892L20.8937 26.4284L20.7627 26.4752L20.6813 26.4941L20.5609 26.5092H20.4391L20.3198 26.4944L20.1943 26.4623L20.0491 26.4009L19.9491 26.3408L19.8099 26.2251L16.8928 23.3082C16.5117 22.9271 16.5117 22.309 16.8928 21.9279C17.2393 21.5814 17.7816 21.5499 18.1636 21.8334L18.2731 21.9279L19.5231 23.1786L19.524 14.4457C19.524 13.9965 19.8275 13.6182 20.2406 13.5046L20.3675 13.4786L20.5 13.4697Z",
    fill: "#272D45",
    stroke: "#272D45",
    strokeWidth: 1.11538
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 27.8846,
    fill: "transparent",
    transform: "translate(6 5.80769)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastextract);
export default __webpack_public_path__ + "static/media/lastextract.2c767b5b91db6b0e06e0e168b678c9a0.svg";
export { ForwardRef as ReactComponent };